import { ReactNode } from 'react-dom';

export interface Hierarchy {
  [key: string]: string[];
}
export interface SDUIModel {
  name: string;
  layoutType: string;
  hierarchy: Hierarchy;
  options?: object;
}

export interface Layout {
  generate: (hierarchy: Hierarchy, getComponentCallback: (string) => ReactNode, options: object) => ReactNode;
}

export enum SduiFeature {
  EXPANDED_PROPERTY_SUMMARY = 'EXPANDED_PROPERTY_SUMMARY'
}
